import React from 'react';
import {
  AVideoType,
  type AVideoProps,
  type AVideoBrightcoveInternalProps,
  type AVideoHtml5InternalProps,
} from './AVideo.types';
import { AVideoBrightcove } from './players/AVideoBrightcove';
import { AVideoHtml5 } from './players/AVideoHtml5';

interface PlayerRegistry {
  [AVideoType.Brightcove]: React.FC<AVideoBrightcoveInternalProps>;
  [AVideoType.Html5]: React.FC<AVideoHtml5InternalProps>;
}

const PLAYER_REGISTRY: PlayerRegistry = {
  [AVideoType.Brightcove]: AVideoBrightcove,
  [AVideoType.Html5]: AVideoHtml5,
};

export function AVideo({ videoType = AVideoType.Html5, ...rest }: AVideoProps): React.ReactElement | null {
  const Player = PLAYER_REGISTRY[videoType] as React.FC<typeof rest>;

  if (!Player) {
    return null;
  }

  return <Player {...rest} />;
}

export { AVideoType, AVideoAspectRatio } from './AVideo.types';
export type { AVideoProps, AVideoHtml5Props, AVideoBrightcoveProps, AVideoBaseProps } from './AVideo.types';
export { TEST_ID as A_VIDEO_BRIGHTCOVE_TEST_ID } from './players/AVideoBrightcove';
export { TEST_ID as A_VIDEO_HTML5_TEST_ID } from './players/AVideoHtml5';
